export default __webpack_public_path__ + "static/media/Banner5.4aa74f4c.jpg";